import { initCore } from 'src/lib/init.js'
import renderComponents from 'src/lib/render-components.js'
import graphsPage from '@/graphs/GraphsPage.vue'
import VueCytoscape from 'vue-cytoscape'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'

import Vue from "vue"

initCore()

Vue.use(VueCytoscape)
renderComponents({
    'graphs-page': graphsPage
})
